import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

interface SentryInitOptions {
    app: App
    router: Router
}

export function initSentry({ app, router }: SentryInitOptions): void {
    const dsn = import.meta.env.VITE_SENTRY_DSN
    const enabled = import.meta.env.VITE_SENTRY_ENABLED !== 'false'

    if (!import.meta.env.PROD || !dsn || !enabled) {
        return
    }

    Sentry.init({
        app,
        dsn,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],
        tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.01'),
        replaysSessionSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || '0'),
        replaysOnErrorSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || '1.0'),
        tracePropagationTargets: [
            'localhost',
            new RegExp(`^${import.meta.env.VITE_API_BASE_URL}`),
        ],
    })
}

export function setSentryUser(user: { id: string | number; email?: string; name?: string } | null): void {
    if (!import.meta.env.PROD) return
    Sentry.setUser(user ? { id: String(user.id), email: user.email, username: user.name } : null)
}

export function captureException(error: Error | unknown, context?: Record<string, unknown>): void {
    if (!import.meta.env.PROD) {
        console.error('[Sentry]', error, context)
        return
    }
    Sentry.captureException(error, { extra: context })
}

export { Sentry }
